import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { ShieldCheck, Eye, Clock, Calendar, Receipt } from 'lucide-react';

const MyWarrantiesList = ({ warranties, navigate, i18n }) => {
  if (!warranties.length) {
    return (
      <div className="max-w-7xl mx-auto mb-8">
        <Card className="bg-[#0d3d3d]/60 border-white/10">
          <CardContent className="py-10 text-center text-white/60">
            <ShieldCheck className="w-10 h-10 mx-auto mb-2 text-white/30" />
            <p className="text-sm">{i18n.language === 'nl' ? 'U heeft nog geen garanties.' : 'No warranties yet.'}</p>
          </CardContent>
        </Card>
      </div>
    );
  }
  return (
    <div className="max-w-7xl mx-auto mb-8" data-testid="client-warranties-section">
      <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-2">
        <ShieldCheck className="w-6 h-6 text-[#3da5a5]" />
        {i18n.language === 'nl' ? 'Mijn Garanties' : 'My Warranties'} ({warranties.length})
      </h2>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {warranties.map((w) => (
          <Card key={w.id} className="bg-[#0d3d3d]/90 border-white/20 hover:border-white/40 transition-all" data-testid={`client-warranty-${w.id}`}>
            <CardContent className="p-5 space-y-3">
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-[10px] uppercase tracking-wider text-white/50">Garantiebewijs</p>
                  <p className="text-lg font-bold text-white">{w.number}</p>
                </div>
                <span className={`text-[10px] px-2 py-0.5 rounded-full ${w.status === 'sent' ? 'bg-emerald-500/20 text-emerald-300' : 'bg-amber-500/20 text-amber-300'}`}>
                  {w.status === 'sent' ? (i18n.language === 'nl' ? 'Verzonden' : 'Sent') : (i18n.language === 'nl' ? 'Concept' : 'Draft')}
                </span>
              </div>
              <div className="text-sm text-white/90 space-y-1">
                <p className="flex items-center gap-2"><Clock className="w-3.5 h-3.5 text-[#3da5a5]" /> {w.period_text}</p>
                {w.issue_date && <p className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5 text-[#3da5a5]" /> {w.issue_date}</p>}
                {w.invoice_reference && <p className="flex items-center gap-2"><Receipt className="w-3.5 h-3.5 text-[#3da5a5]" /> Factuur {w.invoice_reference}</p>}
              </div>
              {w.work_description && (
                <p className="text-xs text-white/60 line-clamp-2" title={w.work_description}>{w.work_description}</p>
              )}
              {w.public_token && (
                <Button
                  size="sm"
                  variant="outline"
                  className="w-full border-[#3da5a5]/40 text-[#3da5a5] hover:bg-[#3da5a5]/10"
                  onClick={() => navigate(`/garantie/${w.public_token}`)}
                  data-testid={`client-view-warranty-${w.id}`}
                >
                  <Eye className="w-4 h-4 mr-1" />
                  {i18n.language === 'nl' ? 'Bekijken & PDF downloaden' : 'View & Download PDF'}
                </Button>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default MyWarrantiesList;
